import { Icon, Typography } from '@repo/ui';
import { useAIMessageFeedback } from '../../../hooks/useAIMessageFeedback';
import { AIMessageFeedbackForm } from './AIMessageFeedbackForm';

import styles from './AIMessageFeedback.module.scss';

interface AIMessageFeedbackProps {
  messageId: string;
  isStreaming: boolean;
  onFeedbackSubmitted: (messageId: string) => void;
}

export const AIMessageFeedback = ({
  messageId,
  isStreaming,
  onFeedbackSubmitted,
}: AIMessageFeedbackProps) => {
  const {
    feedbackState,
    handleThumbsUp,
    handleThumbsDown,
    handleSubmitFeedback,
  } = useAIMessageFeedback(messageId, isStreaming, onFeedbackSubmitted);

  const showFeedbackForm =
    feedbackState === 'dislike' || feedbackState === 'submitted';

  return (
    <div className={styles.feedbackContainer}>
      <div className={styles.feedbackPrompt}>
        <Typography variant='body-xs' className={styles.promptText}>
          Was this helpful?
        </Typography>
        <div className={styles.thumbsButtons}>
          <button
            className={styles.thumbButton}
            onClick={handleThumbsUp}
            disabled={feedbackState !== 'none' || isStreaming}
            aria-label='Thumbs up'
          >
            <Icon
              name={feedbackState === 'like' ? 'thumbsUpFilled' : 'thumbsUp'}
              size='s'
              className={feedbackState === 'like' ? styles.iconSelected : ''}
            />
          </button>
          <button
            className={styles.thumbButton}
            onClick={handleThumbsDown}
            disabled={feedbackState !== 'none' || isStreaming}
            aria-label='Thumbs down'
          >
            <Icon
              name={
                feedbackState === 'dislike' || feedbackState === 'submitted'
                  ? 'thumbsDownFilled'
                  : 'thumbsDown'
              }
              size='s'
              className={
                feedbackState === 'dislike' || feedbackState === 'submitted'
                  ? styles.iconSelected
                  : ''
              }
            />
          </button>
        </div>
      </div>

      {showFeedbackForm && (
        <AIMessageFeedbackForm
          onSubmit={handleSubmitFeedback}
          isSubmitted={feedbackState === 'submitted'}
        />
      )}
    </div>
  );
};
